import { render, staticRenderFns } from "./ChangeToPartner.vue?vue&type=template&id=3cad9c28"
import script from "./ChangeToPartner.vue?vue&type=script&lang=js"
export * from "./ChangeToPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports